import type { SupportedChain } from "./chainIds"

export const NETWORK_NAMES: Record<SupportedChain, string> = {
  1: "Ethereum",
  56: "Binance Smart Chain",
  137: "Polygon",
  43114: "Avalanche",
}
